'use strict';

module Patersons {

    export interface ViewPortfolioScope extends ng.IScope {
        dashboardForm: ng.IFormController;
        events: Patersons.PortfolioViewCtrl;
        portfolio: Array<Account>;
        xRayPortfolios: MorningStarXrayPortfolio[];
        xRayComparePortfolios: MorningStarXrayPortfolio[];
        selectedAccount: Account;
        selectedAccountId: string;
        compareAccountId: string;
        ChangeAccount;
        CompareAccount;
        parentController: AbstractController;
        date: Date;
        isLoading: boolean;
    }

    export class PortfolioCompareCtrl extends AbstractController {
        portfolioService: Patersons.PortfolioService;
        scope: Patersons.ViewPortfolioScope;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.scope.date = new Date();
            this.scope.parentController = this;


			
            //this.scope.portfolio = this.portfolioService.getPortfolioData();
            //this.setSelectedAccount(this.scope.accounts[1].AccountId);
            //if (this.location.search().a != null) {
            //    this.scope.selectedAccountId = this.location.search().a;
            //}
            //if (this.location.search().c != null) {
            //    //  the compare account id parameter
            //    this.scope.compareAccountId = this.location.search().c;
            //    this.log.info("CompareAccountId = " + this.scope.compareAccountId);
            //    this.getPortfolioData(this.baseUrl, this.scope.compareAccountId, this.scope.xRayComparePortfolios);
            //}
            //else {
            //    this.log.info("AccountId = " + this.scope.selectedAccountId);
            //    this.getPortfolioData(this.baseUrl, this.scope.selectedAccountId, this.scope.xRayPortfolios);
            //}

            //this.scope.ChangeAccount = function () {
            //    var accId = this.scope.selectedAccountId;
            //    this.scope.xRayPortfolios = this.scope.parentController.getPortfolioData(this.scope.parentController.baseUrl, accId);
            //    this.scope.parentController.setSelectedAccount(accId);
            //}
            //this.scope.CompareAccount = function () {
            //    var accId = this.scope.selectedAccount.AccountId;
            //    var caccId = this.scope.compareaccount.AccountId;
            //    var url = "/comparePortfolios?a=" + accId + "&c=" + caccId;
            //    this.location.url(url);
            //}
        }
        //setSelectedAccount(accountId: string) {
        //    if (this.scope.accounts != null) {
        //        this.scope.accounts.forEach((acc) => {
        //            if (acc.AccountId == accountId) {
        //                this.scope.selectedAccount = acc;
        //                this.scope.selectedAccountId = acc.AccountId;
        //            }
        //        })
        //    }
        //}
        //mapPortfolioResponseData(response, portfolios) {
        //    var portfolio = new MorningStarXrayPortfolio();
        //    portfolio.benchmark = new MorningStarXrayIdentifier('EUCA000620', 'MSID', 0);
        //    response.data.Holdings.forEach((holding) => {

        //        portfolio.holdingAllocation.push(new MorningStarXrayIdentifier(holding.ISIN, 'ISIN', holding.AverageCost));
        //    })
        //    portfolios = new Array<MorningStarXrayPortfolio>();
        //    portfolios.push(portfolio);

        //    return portfolio;// response.data;
        //}
        //getPortfolioData(baseUrl?: string, id?: string, portfolios ?: MorningStarXrayPortfolio[]): any {
        //    var Url = baseUrl + "/dataService/api/portfoliosummary";
        //    this.log.info("portfolioService getting data with query " + Url);
        //    var data = {
        //        AccountId: id
        //    };

        //    var config = {
        //        params: data,
        //        headers: { 'Accept': 'application/json' }
        //    };


        //    this.http.get(Url, config )
        //        .then((result) => { return this.mapPortfolioResponseData(result, portfolios); },
        //        this.errorHandler("Error retrieving porfolio summary", Url));
        //};     
    }
}
